import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/joget': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M378.1 45c116.6 71.8 152.9 224.6 81 341.2-71.9 116.5-224.6 152.8-341.2 80.9-116.6-71.9-152.9-224.6-81-341.2 46.9-76 128.1-117.9 211.3-117.9 44.4 0 89.4 11.9 129.9 37zM429.9 368.2c5.3-8.7 9.9-17.6 13.9-26.6-32.1 1.1-157.1-1.5-208.8 17.6-58.4 21.5-36.9 53.4-31.2 67.1 3.8 9.1 14.7 28.8 23.7 42.4 6.8 0.6 13.6 1 20.4 1 71.6 0 141.6-36 182-101.5zM229.1 281.9c51 1.3 205.4 4.4 230.3 4.9 11.9-81.8-24.5-166.6-99.3-212.7-100.5-61.9-232.1-30.7-294 69.8-28.6 46.4-37.3 99.4-28.5 149.1 11-40.9 49.7-131.5 178.3-140.2 50.9-4 41.5 19.2 23.6 29.7-17.8 10.5-45.7 23.8-68.9 51.2-23.2 27.4 3 46.8 58.5 48.2zM412.9 227.1c22.7 6 19.1 15.5 19.1 15.5l-46.5 23.4-169.5 1.6s33.8-10.8 65.3-31.3c26-16.9 49.7-35.6 67.5-35.6 3.7 0 7.2 0.9 10.4 2.7 18.5 10.6-2.9 18.2-13.4 24.6s-50.7 34.5-50.7 34.5 1.4 7.6 31.1-8.2c29.7-15.9 64-33.2 86.7-27.2z'
      }
    ]
  }
})
